import {saveAs} from 'file-saver'

export function fileDownload(resp) {
  const contentDisposition = resp.headers['content-disposition']
  let fileName = 'file'
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(
      /filename[^;\n]*=(UTF-\d['"]*)?((['"]).*?[.]$\2|[^;\n]*)?/
    )
    if (fileNameMatch.length === 2) fileName = fileNameMatch[1]
    if (fileNameMatch.length > 2) fileName = decodeURI(fileNameMatch[2])
  }
  let file = new File([resp.data], fileName, {type: resp.data.type || resp.headers['content-type']})
  saveAs(file)
}
